module.exports = __webpack_public_path__ + "static/media/tooltip.999efb78.svg";